import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const INPUT_OFFER_PRICE = 'OFFER :: INPUT_OFFER_PRICE';

export type TInputOfferPriceAction = IReduxAction<typeof INPUT_OFFER_PRICE>;

/**
 * inputOfferPrice vs changeOfferPrice:
 * inputOfferPrice - вызывается при каждом вводе символа в поле "Цена объявления"
 * changeOfferPrice - вызывается только тогда, когда пользователь закончил вводить ставку
 */
export const inputOfferPrice = actionGenerator<typeof INPUT_OFFER_PRICE>(INPUT_OFFER_PRICE);
